// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.PresenceControl.Id,
      ModuleProcessMappings.ActivityControl.Id,
    ],
  },
}));

export function presence() {
  return defineConfig({
    NoPermitirModificarMarcajePresencia: {
      source: ConfigurationParameterSource.ERP,
      component: 'ControlPresencia',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PermitirReiniciarServicioCapturaMarcajesAPP: {
      source: ConfigurationParameterSource.ERP,
      component: 'ControlPresencia',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      loadingRules: {
        ...defaultProps.loadingRules,
        requiredProcessIds: [
          ModuleProcessMappings.ActivityControl.Processes.ProductiveActivityLine.Id,
        ],
      },
    },
    HoraInicioJornada: {
      source: ConfigurationParameterSource.ERP,
      component: 'ControlPresencia',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      loadingRules: {
        requiredModuleIds: [
          ModuleProcessMappings.ProductionControl.Id,
        ],
        requiredProcessIds: [
          ModuleProcessMappings.ProductionControl.Processes.ProductionPlanner.Id,
        ],
      },
    },
    PrefijoTrabajadoresAlmacen: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: '',
      loadingRules: {
        ...defaultProps.loadingRules,
        requiredProcessIds: [
          ModuleProcessMappings.PresenceControl.Submodules.AttendanceManagement.Processes.MassiveAttendanceRecords.Id,
        ],
      },
    },
  });
}
